export default __webpack_public_path__ + "drag-and-drop@2x.png";